export type LocationId = 'casa' | 'trabalho' | 'escola' | 'loja' | 'bar';

export const CORE_WORK_START = 9;
export const CORE_WORK_END = 17;
export const CORE_WORK_HOURS = CORE_WORK_END - CORE_WORK_START;

export const LOCATION_IDS: readonly LocationId[] = Object.freeze([
  'casa',
  'trabalho',
  'escola',
  'loja',
  'bar',
]);

export type Location = {
  readonly id: LocationId;
  readonly openHour: number;
  readonly closeHour: number;
  readonly emoji: string;
};

export const LOCATIONS: Readonly<Record<LocationId, Location>> = Object.freeze({
  casa: { id: 'casa', openHour: 0, closeHour: 0, emoji: '🏠' },
  trabalho: { id: 'trabalho', openHour: 6, closeHour: 20, emoji: '💼' },
  escola: { id: 'escola', openHour: 8, closeHour: 0, emoji: '🎓' },
  loja: { id: 'loja', openHour: 9, closeHour: 22, emoji: '🛒' },
  bar: { id: 'bar', openHour: 18, closeHour: 4, emoji: '🍺' },
});

export const TRAVEL_HOURS: Readonly<Record<LocationId, Readonly<Record<LocationId, number>>>> =
  Object.freeze({
    casa: Object.freeze({ casa: 0, trabalho: 1, escola: 1, loja: 1, bar: 1 }),
    trabalho: Object.freeze({ casa: 1, trabalho: 0, escola: 1, loja: 1, bar: 1 }),
    escola: Object.freeze({ casa: 1, trabalho: 1, escola: 0, loja: 1, bar: 1 }),
    loja: Object.freeze({ casa: 1, trabalho: 1, escola: 1, loja: 0, bar: 1 }),
    bar: Object.freeze({ casa: 1, trabalho: 1, escola: 1, loja: 1, bar: 0 }),
  });

export function travelHours(from: LocationId, to: LocationId): number {
  return TRAVEL_HOURS[from][to];
}
